<div class="main-nav-container">
  <div
    class="logo-container"
    [routerLink]="['home']"
    [style.cursor]="'pointer'"
  >
    <img
      [ngSrc]="'main-side-navigation-sustainment-logo.png'"
      width="148"
      height="24"
    />
  </div>
  <div class="inner-main-nav-container">
    <div class="nav-items-container">
      @for (item of navItems(); track item.title) {
        @let urlPath = "/" + item.url.join("/");

        <app-main-nav-item
          [item]="item"
          (panelToggled)="onPanelToggled($event)"
          [isCollapsed]="
            !item.subNavItems?.length
              ? !currentUrl().startsWith(urlPath)
              : !currentlyOpenNavItems().includes(item.title)
          "
          [currentRoute]="currentUrl()"
        />
      }
    </div>
    <button
      type="button"
      (click)="createMenu.toggle($event)"
      [ngClass]="{ 'create-button': true, 'menu-open': createMenu.visible }"
    >
      <div class="text-wrapper">
        <i class="ti ti-plus"></i>
        <span class="label">Add</span>
      </div>
      <i
        [ngClass]="{
          ti: true,
          'create-angle': true,
          'ti-chevron-down': !createMenu.visible,
          'ti-chevron-up': createMenu.visible
        }"
      ></i>
    </button>
  </div>
  <p-menu
    #createMenu
    [model]="createButtonMenuItems()"
    [popup]="true"
    [appendTo]="'body'"
    [styleClass]="'create-menu'"
  />
</div>

<p-overlayPanel
  #projectlimitSidebar
  styleClass="gray-overlay project-limit-overlay"
>
  <app-project-limit-popover
    [isAdmin]="isAdmin"
    (onNavigate)="projectlimitSidebar.hide()"
  ></app-project-limit-popover>
</p-overlayPanel>
